import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO'; // Asumiendo que tienes un componente SEO
// import SectionHeader from '../components/SectionHeader'; // Descomenta si tienes un componente reutilizable
import { Target, Eye, Award, CheckCircle } from 'lucide-react'; // <--- AÑADIDO: Importar iconos
import { cn } from '@/lib/utils'; // <--- AÑADIDO: Asumiendo que cn está disponible

// Datos del equipo REORDENADOS Y ACTUALIZADOS
const teamMembers = [
  {
    name: 'Aless',
    title: 'CEO & Visionario Tecnológico', // Actualizado
    image: '/images/equipo/aless.jpg',
    description: 'Aless lidera Innotec con una pasión por la tecnología punta, impulsando soluciones innovadoras y eficientes para la industria alimentaria global.',
  },
  {
    name: 'Juan',
    title: 'Presidente & Fundador', // Actualizado
    image: '/images/equipo/juan.jpg',
    description: 'Fundador de Innotec, Juan aporta su vasta experiencia y visión estratégica, guiando el crecimiento y la consolidación de la empresa en el mercado.',
  },
  {
    name: 'Sara',
    title: 'Directora Comercial Global', // Actualizado
    image: '/images/equipo/sara.jpg',
    description: 'Sara es el puente entre Innotec y nuestros clientes, asegurando relaciones sólidas y entendiendo a fondo las necesidades del mercado para ofrecer valor.',
  },
   {
    name: 'Pepe',
    title: 'Director de Operaciones Estratégicas', // Actualizado
    image: '/images/equipo/pepe.jpg',
    description: 'Pepe orquesta la maquinaria interna de Innotec, garantizando la excelencia operativa y la ejecución impecable de cada proyecto.',
  },
  // Puedes añadir más miembros si es necesario
];

// Variantes de animación con ligero ajuste
const cardVariants = {
  hidden: { opacity: 0, y: 25 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.12, // Un poco más escalonado
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1.0], // Curva de ease personalizada
    },
  }),
};

// --- AÑADIDO: Datos para Misión, Visión y Valores ---
const missionVisionValuesData = [
  {
    title: 'Misión',
    description: 'Impulsar la eficiencia y la innovación en la industria alimentaria a través de soluciones tecnológicas de vanguardia, personalizadas para las necesidades de cada cliente, garantizando calidad, sostenibilidad y crecimiento.',
    icon: <Target className="w-7 h-7 text-[#FCAA0D]" />,
    items: []
  },
  {
    title: 'Visión',
    description: 'Ser el referente global en equipamiento y tecnología para la industria alimentaria, reconocidos por nuestra excelencia, nuestro compromiso con el cliente y nuestra contribución a un sector más productivo y sostenible.',
    icon: <Eye className="w-7 h-7 text-[#FCAA0D]" />,
    items: []
  },
  {
    title: 'Valores Fundamentales',
    icon: <Award className="w-7 h-7 text-[#FCAA0D]" />,
    description: '', // Sin descripción general, se usan items
    items: [
      { text: 'Innovación Constante:', detail: 'Buscamos activamente nuevas y mejores formas de resolver los desafíos de nuestros clientes.' },
      { text: 'Compromiso con el Cliente:', detail: 'Su éxito es nuestro éxito. Nos dedicamos a entender y satisfacer sus necesidades.' },
      { text: 'Calidad Superior:', detail: 'Ofrecemos productos y servicios que superan los estándares de la industria.' },
      { text: 'Integridad y Transparencia:', detail: 'Actuamos con honestidad y claridad en todas nuestras interacciones.' },
      { text: 'Colaboración y Equipo:', detail: 'Fomentamos un ambiente de trabajo colaborativo donde cada voz es valorada.' },
    ]
  },
];
// --- FIN AÑADIDO ---

const TeamPage: React.FC = () => {
  return (
    // Fondo oscuro principal
    <div className="bg-[#0A0A0B] min-h-screen text-gray-200">
      <SEO
        title="Nuestro Equipo | Innotec Food Equipment"
        description="Conoce al equipo de expertos apasionados detrás de Innotec Food Equipment, dedicados a impulsar la industria alimentaria."
        canonicalUrl="/equipo" // Corregido /team a /equipo si esa es la ruta final
      />

      <div className="container mx-auto px-4 pt-8 pb-16 md:pt-12 md:pb-24">
        {/* Encabezado */}
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12 md:mb-20" // Aumentado margen inferior
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Conoce a nuestro <span className="text-[#FCAA0D]">equipo</span>
          </h1>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Profesionales apasionados y dedicados a encontrar la solución perfecta para ti.
          </p>
        </motion.div>

        {/* Grid de Miembros del Equipo - NUEVO DISEÑO */}
        {/*
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10"> // Reducido gap ligeramente
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              className="flex flex-col bg-gray-900/30 rounded-lg overflow-hidden shadow-xl backdrop-blur-sm border border-white/5 group transition-all duration-300 hover:bg-gray-900/50 hover:border-white/10"
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants}
              whileHover={{ y: -5 }} // Efecto hover más sutil
              transition={{ type: 'spring', stiffness: 400, damping: 17 }}
            >
              <div className="aspect-[4/5] relative overflow-hidden">
                <img
                  src={member.image}
                  alt={`Foto de ${member.name}`}
                  className="object-cover w-full h-full transition-all duration-500 brightness-105 group-hover:brightness-100 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent pointer-events-none"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white z-10">
                  <h3 className="text-lg font-semibold mb-0.5 truncate">
                    {member.name}
                  </h3>
                  <p className="text-xs font-medium text-[#FCAA0D]">
                    {member.title}
                  </p>
                </div>
              </div>

              <div className="p-4 pt-3 flex-grow">
                <p className="text-gray-400 text-xs leading-relaxed transition-colors duration-300 group-hover:text-gray-300">
                  {member.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
        */}

        {/* Imagen de equipo completo (adaptada a fondo oscuro) */}
         <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-16 md:mt-24 text-center" // Aumentado margen superior
         >
             <img
                src="/images/equipo/full-team.jpg"
                alt="Equipo completo de Innotec Food"
                className="rounded-xl shadow-2xl mx-auto max-w-5xl w-full border-2 border-[#FCAA0D]/50" // Borde más destacado y sombra más pronunciada
            />
         </motion.div>

        {/* Nueva Sección: Nuestra Misión y Valores - REFACTORIZADA */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-20 md:mt-32"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 md:mb-16 text-center">
            Nuestra Misión, Visión y <span className="text-[#FCAA0D]">Valores</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto px-4">
            {missionVisionValuesData.map((item, index) => (
              <motion.div
                key={item.title}
                className={cn(
                  "group relative flex flex-col p-6 rounded-xl overflow-hidden transition-all duration-300 will-change-transform",
                  "bg-gray-900/70 dark:bg-black/50 backdrop-blur-md",
                  "border border-white/10",
                  "hover:border-[#FCAA0D]/70 hover:shadow-[0_8px_30px_rgb(252,170,13,0.2)] hover:-translate-y-1.5"
                )}
                custom={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={cardVariants} // Reutilizando cardVariants para consistencia de animación
              >
                {/* Patrón de fondo sutil */}
                <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-300 -z-10">
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,170,13,0.03)_1px,transparent_1px)] dark:bg-[radial-gradient(circle_at_center,rgba(252,170,13,0.05)_1px,transparent_1px)] bg-[length:8px_8px]" />
                </div>
                 {/* Gradiente de borde sutil en hover */}
                <div className={cn(
                    "absolute inset-0 -z-20 rounded-xl p-px transition-opacity duration-300 opacity-0 group-hover:opacity-100",
                    "bg-gradient-to-br from-[#FCAA0D]/30 via-transparent to-transparent" // Ajustado para el color de acento
                )} />


                <div className="flex-grow flex flex-col">
                  <div className="mb-5 inline-flex items-center justify-center p-3.5 rounded-xl bg-[#FCAA0D]/10 group-hover:bg-[#FCAA0D]/20 transition-colors duration-300">
                    {item.icon}
                  </div>
                  <h3 className="text-xl lg:text-2xl font-semibold text-white mb-3.5">
                    {item.title}
                  </h3>
                  {item.description && (
                    <p className="text-gray-300 dark:text-gray-400 text-sm lg:text-[0.95rem] leading-relaxed">
                      {item.description}
                    </p>
                  )}
                  {item.items && item.items.length > 0 && (
                    <ul className="space-y-2.5 mt-3 text-sm lg:text-[0.95rem]">
                      {item.items.map((listItem, idx) => (
                        <li key={idx} className="flex items-start text-gray-300 dark:text-gray-400">
                          <CheckCircle className="w-5 h-5 text-[#FCAA0D] mr-2.5 mt-[3px] flex-shrink-0" />
                          <span className="leading-relaxed">
                            <span className="font-medium text-gray-200 dark:text-gray-300">{listItem.text}</span> {listItem.detail}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

      </div>
    </div>
  );
};

export default TeamPage;
